<!--
    描述：
    时间：2020-05-13
    Created by zwh
-->
<template>
    <iframe class="h100 w100" frameborder=0 name="showHere" scrolling=auto :src="url" title="iframe"></iframe>
</template>

<script>
    export default {
        components: {},
        props : {},
        data() {
            return {
                url : 'https://www.activiti.org',
            }
        },
        computed: {},
        mounted() {},
        watch: {},
        created() {},
        methods: {

        }
    }
</script>

<style scoped>

</style>